import React from 'react';
import TinyAnalytics from 'views/tiny/TinyAnalytics.js';

function TinyAnalyticsContainer() {
  return <TinyAnalytics />;
}

export default TinyAnalyticsContainer;


